document.addEventListener('DOMContentLoaded', async () => {
  await addRecentlyViewedProduct();
});

function getRecentlyViewedProducts() {
  let viewedProducts = [];
  const obj = localStorage.getItem('recently_viewed_products');
  if (obj !== null) {
    viewedProducts.push(obj);
  }
  return viewedProducts;
}

async function addRecentlyViewedProduct() {
  const { product } = await fetch(`${window.location.href}.json`).then((resp) => resp.json());

  const viewedProducts = getRecentlyViewedProducts();

  const index = viewedProducts.indexOf(product.handle);
  if (index > -1) {
    viewedProducts.splice(index, 1);
  }

  if (viewedProducts.length >= 4) {
    viewedProducts.pop();
  }

  viewedProducts.unshift(`${window.location.href}.json`);

  localStorage.setItem('recently_viewed_products', viewedProducts);
}
